import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.palette.grey[100],
  },
  appBar: {
    backgroundColor: '#fff',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    color: theme.palette.text.primary,
  },
  title: {
    flexGrow: 1,
  },
  iframe: {
    width: '100%',
    height: '100vh',
    border: 'none',
  },
  overlay: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(255,255,255,0.9)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    zIndex: 10,
  },
  errorIcon: {
    fontSize: 64,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  button: {
    textTransform: 'none',
  },
}))

export { useStyles }
